import { XApp } from '@core/utils';

export const getApiUrlFromEndpoint = (
  endpoint: string,
  globalConfigNestedFields?: string[]
) => {
  const endpointIsDirectUrl =
    endpoint.includes('http://') || endpoint.includes('https://');

  return endpointIsDirectUrl
    ? endpoint
    : `${XApp.getApiUrlFromGlobal(globalConfigNestedFields)}${endpoint}`;
};
